import { render, staticRenderFns } from "./staffing-agency-in-india.vue?vue&type=template&id=2ec1c40a&scoped=true&"
import script from "./staffing-agency-in-india.vue?vue&type=script&lang=js&"
export * from "./staffing-agency-in-india.vue?vue&type=script&lang=js&"
import style0 from "./staffing-agency-in-india.vue?vue&type=style&index=0&id=2ec1c40a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec1c40a",
  null
  
)

export default component.exports